<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="送货日期：">
            <el-date-picker size="medium" v-model="searchForm.date" type="date" placeholder="选择日期" :clearable="false" @change="queryGroup"
              value-format="yyyy-MM-dd" style="width: 200px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="分组：">
            <el-select size="medium" filterable v-model="searchForm.groupID" style="width: 200px;" :clearable="true" @change="getGroupLable">
              <el-option v-for="item in groupList" :key="item.ID" :label="item.LINE_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="querryData" style="float:right">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 20px">
      <el-col :span="24">
        <el-button size="medium" @click="openExportProject">项目配送单导出</el-button>
        <el-button size="medium" type="primary" plain @click="exportExcelThre">导出三列配送单</el-button>
        <el-button size="medium" type="primary" plain @click="exportExcel">导出</el-button>
        <el-button size="medium" type="primary" plain @click="exportPriceExcel">带价格导出</el-button>
        <el-button size="medium" type="primary" plain @click="exportExcelByLine">分线路导出</el-button>
        <el-button size="medium" @click="printTable" type="primary">打印</el-button>
      </el-col>
    </el-row>
    <el-tabs type="border-card" @tab-click="handleTabClick">
      <el-tab-pane label="团餐客户">
        <el-row>
          <el-col :span="10">
            <span>{{ this.name }}</span>
          </el-col>
        </el-row>
        <el-row style="margin-top:20px">
          <el-col :data="tableData" v-for="item in tableData" :key="item.INCOME_DATE">
            <table cellpadding="0" cellspacing="0" style="width:100%" class="sending">
              <caption class="table-title" style="">{{ item.D_NAME }}</caption>
              <tr class="table-line" v-for="index in item.DATA" :key="index.INCOME_DATE">
                <td class="product" style="width:60%;">{{ index.P_NAME }}</td>
                <td class="product" style="width:20%;text-align:center">{{ index.PRODUCT_COUNT }}</td>
                <td class="product" style="width:150px;text-align:center">{{ index.TYPE_UNIT }}</td>
              </tr>
            </table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="供应商客户">
        <el-row>
          <el-col :span="10">
            <span>{{ this.name }}</span>
          </el-col>
        </el-row>
        <el-row style="margin-top:20px">
          <el-col :data="tableData" v-for="item in tableData" :key="item.INCOME_DATE">
            <table cellpadding="0" cellspacing="0" style="width:100%" class="sending">
              <caption class="table-title" style="">{{ item.D_NAME }}</caption>
              <tr class="table-line" v-for="index in item.DATA" :key="index.INCOME_DATE">
                <td class="product" style="width:60%;">{{ index.P_NAME }}</td>
                <td class="product" style="width:20%;text-align:center">{{ index.PRODUCT_COUNT }}</td>
                <td class="product" style="width:150px;text-align:center">{{ index.TYPE_UNIT }}</td>
              </tr>
            </table>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="导出配送单" center :visible.sync="exportDeliveryVisible" width="630px" :close-on-click-modal="false">
      <el-form ref="exportDeliveryForm" :model="exportDeliveryForm" :label-width="formLabelWidth">
        <!-- <el-form-item label="客户名称：">
          <el-select filterable v-model="exportDeliveryForm.customer" style="width:80%" @change="queryProject($event)">
            <el-option v-for="item in customers" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="项目点：">
          <label slot="label">项&nbsp;目&nbsp;&nbsp;点：</label>
          <el-select filterable v-model="exportDeliveryForm.project" style="width:80%">
            <el-option v-for="item in projects" :key="item.PROJECT_ID" :label="item.PROJECT_NAME" :value="item.PROJECT_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货日期：" :label-width="formLabelWidth">
          <el-date-picker v-model="exportDeliveryForm.DATE_VALUE" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportDeliveryVisible = false">取 消</el-button>
        <el-button type="primary" @click="exportProject">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <el-row>
            <el-col :span="10">
                <span>{{this.name}}</span>
            </el-col>
        </el-row>
        <el-row  style="margin-top:20px">
            <el-col :data="tableData" v-for="item in tableData" :key="item.INCOME_DATE">
                <table cellpadding="0" cellspacing="0" style="width:100%" class="sending">
                    <caption class="table-title" style="">{{item.D_NAME}}</caption>
                    <tr class="table-line" v-for="index in item.DATA" :key="index.INCOME_DATE">
                        <td class="product" style="width:60%;">{{index.P_NAME}}</td>
                        <td class="product" style="width:20%;text-align:center">{{index.PRODUCT_COUNT}}</td>
                        <td class="product" style="width:150px;text-align:center">{{index.TYPE_UNIT}}</td>
                    </tr>
                </table>
            </el-col>
        </el-row> -->
  </div>
</template>
<script>
import {
  sendingOrderFun, exportSendOrderFun, exportSendOrderAndPriceFun, queryGroupFun, exportSendOrderFunTre,
} from 'api/sendingOrder';
import { getEnteyCusFun, haveXMDFun } from 'api/sellOrder';
import { print } from 'api/warehouseManager';
import date from '@/assets/common/date';
import http from '../../assets/common/http';

export default {
  data() {
    return {
      searchForm: {
        date: date(new Date(), '%F'),
      },
      tableData: [],
      name: '',
      groupList: [],
      groupName: '',
      currentOrderFlag: 0,
      exportDeliveryVisible: false,
      exportDeliveryForm: {
        DATE_VALUE: '',
      },
      customers: [],
      projects: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          },
        }],
      },
      formLabelWidth: '120px',
    };
  },
  methods: {
    // ------------------------------进入页面拉取数据
    querryData() {
      const params = {};
      if (this.searchForm.date) {
        params.SEND_DAY = date(this.searchForm.date, '%F');
      }
      if (this.searchForm.groupID) {
        params.GROUP_ID = this.searchForm.groupID;
      } else {
        this.groupName = '';
      }
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      sendingOrderFun(params)
        .then((result) => {
          if (result[0]) {
            this.tableData = result[0].DATA;
            this.name = result[0].COMPANY_NAME;
          } else {
            this.tableData = [];
            this.name = '';
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // ------------------------------------------获取分组
    queryGroup() {
      const params = {
        SEND_DAY: date(this.searchForm.date, '%F'),
      };
      queryGroupFun(params)
        .then((result) => {
          if (result) {
            this.groupList = result;
          } else {
            this.groupList = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 导出三列
    exportExcelThre() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {};
          if (this.searchForm.date) {
            params.SEND_DAY = date(this.searchForm.date, '%F');
          }
          if (this.searchForm.groupID) {
            params.GROUP_ID = this.searchForm.groupID;
          }
          if (this.currentOrderFlag == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
          }
          if (!this.searchForm.date) {
            this.$message.show({ text: '请选择送货日期', type: 'warning' });
            return false;
          }
          exportSendOrderFunTre(params).then((result) => {
            if (result[0]) {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              document.body.style.cursor = 'default';
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    // ------------------------导出配送单
    exportExcel() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {};
          if (this.searchForm.date) {
            params.SEND_DAY = date(this.searchForm.date, '%F');
          }
          if (this.searchForm.groupID) {
            params.GROUP_ID = this.searchForm.groupID;
          }
          if (this.currentOrderFlag == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
          }
          if (!this.searchForm.date) {
            this.$message.show({ text: '请选择送货日期', type: 'warning' });
            return false;
          }
          exportSendOrderFun(params).then((result) => {
            if (result[0]) {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              document.body.style.cursor = 'default';
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // -------------------------导出代价格配送单
    exportPriceExcel() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {};
          if (this.searchForm.date) {
            params.SEND_DAY = date(this.searchForm.date, '%F');
          }
          if (this.searchForm.groupID) {
            params.GROUP_ID = this.searchForm.groupID;
          }
          if (this.currentOrderFlag == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
          }
          if (!this.searchForm.date) {
            this.$message.show({ text: '请选择送货日期', type: 'warning' });
            return false;
          }
          exportSendOrderAndPriceFun(params)
            .then((result) => {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {}
      }
    },
    handleTabClick(tab, event) {
      this.currentOrderFlag = Number(tab.index);
      this.querryData();
    },
    getGroupLable(e) {
      if (e) {
        let tmp = [];
        tmp = this.groupList.filter((item) => item.ID == e);
        this.groupName = tmp[0].LINE_NAME;
      }
    },
    printTable() {
      let html = '<div>';
      html += '<div class="main">';
      html += `<div class="title" style="font-size: 20px"><b>${this.groupName}配送单</b></div>`;
      this.tableData.forEach((item, indexOne) => {
        const dataInfo = item.DATA;
        html += '<div>';
        html += `<div>日期：${date(this.searchForm.date, '%F')}</div>`;
        html += '<table border="1" cellspacing="0" style="font-size: 13px"><div class="el-table__body el-table__header">';
        html += `<caption class="table-title" style="font-size: 16px;padding: 5px">${`${item.D_NAME}(${item.LINE_NAME})`}</caption>`;
        html += '<tr style="text-align: center" class="table-line"><th style="width:50px;">序号</th><th style="width:270px;">产品名称</th><th style="width:50px;text-align:center">数量</th> <th style="width:45px;text-align:center">单位</th><th style="width:80px;text-align:center">备注</th></tr>';
        html += '</div><div class="el-table__body">';
        dataInfo.forEach((infoItem, index) => {
          html += '<tr style="text-align: center" class="table-line">';
          html += `<td>${index + 1}</td><td>${infoItem.NAME}</td><td style="text-align:center">${infoItem.PRODUCT_COUNT}</td>
                        <td style="text-align:center">${infoItem.TYPE_UNIT}</td><td>${infoItem.DESCRIPTION}</td>`;
          html += '</tr>';
        });
        html += '</div>';
        html += '</table>';
        html += '</div>';
      });
      html += '</div>';
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
    openExportProject() {
      // this.queryCustomer();

      this.queryProject();
      this.exportDeliveryVisible = true;
    },
    // 选择客户
    queryCustomer() {
      getEnteyCusFun()
        .then((result) => {
          if (result.length !== 0) {
            this.customers = result;
          } else {
            this.customers = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 选择项目点
    queryProject(event) {
      this.$set(this.exportDeliveryForm, 'project', '');
      for (let i = 0; i < this.customers.length; i++) {
        if (this.customers[i].ID === event) {
          sessionStorage.setItem('TC_NAME', this.customers[i].AB_NAME);
        }
      }
      // const paramsProject = {
      //   TC_ID: this.exportDeliveryForm.customer,
      // };
      haveXMDFun()
        .then((result) => {
          if (result[0]) {
            this.projects = result[0].project;
          } else {
            this.projects = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    exportProject() {
      const params = {
        SERVICE_ID: '10042',
        OTYPE: 31,
        USER_ID: Number(sessionStorage.getItem('userId')),
        SESSION: String(sessionStorage.getItem('session')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        // TC_ID: Number(this.exportDeliveryForm.customer),
        SEND_DAY: this.exportDeliveryForm.DATE_VALUE[0],
        END_DAY: this.exportDeliveryForm.DATE_VALUE[1],
      };
      if (this.exportDeliveryForm.project) {
        params.PROJECT_ID = this.exportDeliveryForm.project;
      }
      http.post(params).then((res) => {
        if (res[0]) {
          window.location.href = res[0].FILE_PATH;
          this.$message.show({ text: '导出成功', type: 'success' });
          this.exportDeliveryForm = {};
          this.exportDeliveryVisible = false;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 分线路导出
    exportExcelByLine() {
      const params = {
        SERVICE_ID: '10021',
        OTYPE: 5,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (!this.searchForm.date) {
        this.$message.show({ text: '请选择送货日期', type: 'warning' });
        return false;
      }
      params.SEND_DAY = this.searchForm.date;

      if (this.searchForm.groupID) {
        params.GROUP_ID = this.searchForm.groupID;
      }
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      http.post(params).then((res) => {
        window.location.href = res[0].FILE_PATH;
      }).catch((err) => {
        this.$message.show({ text: '暂无数据，或配送项目点未分配线路', type: 'warning' });
      });
    },
  },
  created() {
    this.querryData();
    this.queryGroup();
  },
};
</script>
<style scoped>
.product {
  color: #606266;
  padding-left: 5px;
  height: 40px;
}

.table-title {
  height: 50px;
  line-height: 50px;
  border: 1px solid #ebeef5;
  color: #909399;
  font-weight: bold;
  border-bottom: 0;
}

.table-line {
  float: left;
  width: 25%;
}

.sending,
.sending tr th,
.sending tr td {
  border: 1px solid #ebeef5;
}
</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/sendingDocument.vue